[
  {
    "id": 1,
    "image": "home-mockup-1.png",
    "label": "mockup-1-label"
  },
  {
    "id": 2,
    "image": "home-mockup-2.png",
    "label": "mockup-2-label"
  },
  {
    "id": 3,
    "image": "home-mockup-3.png",
    "label": "mockup-3-label"
  },
  {
    "id": 4,
    "image": "home-mockup-4.png",
    "label": "mockup-4-label"
  },
  {
    "id": 5,
    "image": "home-mockup-5.png",
    "label": "mockup-5-label"
  },
  {
    "id": 6,
    "image": "home-mockup-6.png",
    "label": "mockup-6-label"
  },
  {
    "id": 7,
    "image": "home-mockup-7.png",
    "label": "mockup-7-label"
  },
  {
    "id": 8,
    "image": "home-mockup-8.png",
    "label": "mockup-8-label"
  }
]
